module.exports = __webpack_public_path__ + "img/bf-add.0c5610a4.svg";